var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-position"},[[_c('div',{staticClass:"custom-tooltip"},[_c('div',{staticClass:"custom-tooltip-row"},[_c('span',{staticClass:"custom-tooltip-row-start-span fw-bold"},[_vm._v("\n          "+_vm._s(_vm.tooltipTextProp)+"\n        ")])])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }